import { render, staticRenderFns } from "./CustomerNotes.vue?vue&type=template&id=50c6204f&"
import script from "./CustomerNotes.vue?vue&type=script&lang=js&"
export * from "./CustomerNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports